export type ApiSchemaCreateVendor = {
  name: string;
  phoneNumber?: string;
  parentCompanyId: string;
  vendorOverflowType: VendorConnectionType;
  vendorOverflowValue: string;
};

export type ApiSchemaVendorCompanyData = {
  id: string;
  name: string;
  code: string;
  isCallForwarding: boolean;
  isCallReForwarding: boolean;
  vendorId?: string;
  reforwardingVendorId?: string;
  reforwardingVendorName?: string;
};

export type ApiSchemaCreateVendorCompany = {
  vendorId: string;
  companyId: string;
};

export type ApiSchemaVendorLanguageData = {
  id: string;
  name: string;
  code: string;
  vendorId: string;
  languageId: string;
};

export type ApiSchemaCreateVendorLanguage = {
  name: string;
  code: string;
  vendorId: string;
  languageId: string;
};

export type ApiSchemaVendorSipHeaderModel = {
  id: string;
  vendorId: string;
  headerName?: string
  headerValue: string
  valueType?: 0 | 1;
};

export type ApiSchemaVendorSipHeaderToken = {
  token: string;
  description: string;
};


export enum VendorConnectionType {
  PhoneNumber = 1,
  SipUrl
}

export type ReforwardingVendorOption = {
  value: string;
  label: string;
  vendorOverflowType: VendorConnectionType;
};

export type ApiSchemaVendorData = {
  id: string;
  name?: string;
  phoneNumber?: string;
  parentCompanyId: string;
  vendorLanguages?: [];
  vendorOverflowType: VendorConnectionType;
  vendorOverflowValue: string;
};

export type ApiSchemaChangeCallForwardingOption = {
  companyId: string;
  isCallForwardingEnabled: boolean;
};

export type ApiSchemaChangeCallReForwardingOption = {
  vendorId: string;
  companyId: string;
  isCallReForwardingEnabled: boolean;
};

export type ApiSchemaAddReforwardingVendor = {
  companyId: string;
  vendorId: string;
  reforwardingVendorId: string;
};

export type VendorRoutParam = {
  companyId: string;
  vendorName: string;
  vendorType: VendorConnectionType;
};
